module.exports = __webpack_public_path__ + "static/scale-model-of-shelton-mcmurphey-johnson-house-in-eugene-oregon-c9cdaf38a719c9c378b909511e3b7c70.png";